import React, { useState, useCallback, useEffect } from 'react';
import { Toaster } from '@/components/ui/sonner';
import BackgroundLayer from '../BackgroundLayer';
import Header from '../Header';
import Footer from '../sections/Footer';
import ChatWidget from '../ChatWidget';
import MobileCTA from '../MobileCTA';
import ExitIntentModal from '../ExitIntentModal';
import LeadModal from '../LeadModal';
import { LeadModalContext } from '../../lib/leadModalContext';
import { initAnalytics, trackEvent } from '../../lib/analytics';

/**
 * Wraps every non-homepage page with the full chrome: header, background, footer,
 * global modals (lead + exit-intent), chat widget, mobile sticky CTA.
 * Analytics init once per mount.
 */
const PageShell = ({ children }) => {
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadSource, setLeadSource] = useState('website');
  const [leadDefaults, setLeadDefaults] = useState({});

  const openLeadModal = useCallback((source = 'website', defaults = {}) => {
    setLeadSource(source);
    setLeadDefaults(defaults);
    setLeadOpen(true);
    trackEvent('trial_click', { source });
  }, []);

  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <LeadModalContext.Provider value={{ openLeadModal }}>
      <div className="App" data-testid="app-root">
        <BackgroundLayer />
        <Header />
        <main>{children}</main>
        <Footer />
        <ChatWidget />
        <MobileCTA />
        <ExitIntentModal />
        <LeadModal
          open={leadOpen}
          onOpenChange={setLeadOpen}
          source={leadSource}
          defaults={leadDefaults}
        />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: 'rgba(15,18,23,0.95)',
              color: '#fff',
              border: '1px solid rgba(255,42,42,0.45)',
            },
          }}
        />
      </div>
    </LeadModalContext.Provider>
  );
};

export default PageShell;
